import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import AppRedirect from "@/pages/AppRedirect";
import RetailerDashboard from "@/pages/RetailerDashboard";
import IssueReceipt from "@/pages/IssueReceipt";
import IssuedReceipts from "@/pages/IssuedReceipts";
import CustomerWallet from "@/pages/CustomerWallet";
import ReceiptDetail from "@/pages/ReceiptDetail";
import ClaimReceipt from "@/pages/ClaimReceipt";
import AddReceipt from "@/pages/AddReceipt";
import Warranties from "@/pages/Warranties";
import Transfers from "@/pages/Transfers";
import ProofPacks from "@/pages/ProofPacks";
import ProofPackPublic from "@/pages/ProofPackPublic";
import { AdminOverview, AdminStores, AdminUsers } from "@/pages/Admin";

const RETAILER_ROLES = ["retailer", "admin"];
const ADMIN_ROLES = ["admin"];

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback before anything else (read from reactive hash).
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/p/:token" element={<ProofPackPublic />} />

      <Route path="/app" element={<ProtectedRoute><AppRedirect /></ProtectedRoute>} />

      {/* Retailer */}
      <Route path="/retailer" element={<ProtectedRoute roles={RETAILER_ROLES}><RetailerDashboard /></ProtectedRoute>} />
      <Route path="/retailer/issue" element={<ProtectedRoute roles={RETAILER_ROLES}><IssueReceipt /></ProtectedRoute>} />
      <Route path="/retailer/receipts" element={<ProtectedRoute roles={RETAILER_ROLES}><IssuedReceipts /></ProtectedRoute>} />

      {/* Customer */}
      <Route path="/wallet" element={<ProtectedRoute><CustomerWallet /></ProtectedRoute>} />
      <Route path="/wallet/add" element={<ProtectedRoute><AddReceipt /></ProtectedRoute>} />
      <Route path="/wallet/receipt/:id" element={<ProtectedRoute><ReceiptDetail /></ProtectedRoute>} />
      <Route path="/claim" element={<ProtectedRoute><ClaimReceipt /></ProtectedRoute>} />
      <Route path="/claim/:code" element={<ProtectedRoute><ClaimReceipt /></ProtectedRoute>} />
      <Route path="/warranties" element={<ProtectedRoute><Warranties /></ProtectedRoute>} />
      <Route path="/transfers" element={<ProtectedRoute><Transfers /></ProtectedRoute>} />
      <Route path="/proof-packs" element={<ProtectedRoute><ProofPacks /></ProtectedRoute>} />

      {/* Admin */}
      <Route path="/admin" element={<ProtectedRoute roles={ADMIN_ROLES}><AdminOverview /></ProtectedRoute>} />
      <Route path="/admin/stores" element={<ProtectedRoute roles={ADMIN_ROLES}><AdminStores /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute roles={ADMIN_ROLES}><AdminUsers /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
